// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=739e4817-e6ff-4556-a332-ef8a90c6a2c3";
};